import { gql } from "@apollo/client";

const GET_TEAM_SCORE = gql`
  query teamScoreFetch($teamId: ID!) {
    teamScoreFetch(teamId: $teamId) {
      week
      weekDate
      score
      scoreDelta
      scoreDeltaPercent
      categoryScores {
        category
        score
        scoreDelta
        scoreDeltaPercent
        sparkline
      }
      team {
        id
        name
      }
      organization {
        id
        name
      }
      sparkline
    }
  }
`;

export { GET_TEAM_SCORE };
